module.exports = __webpack_public_path__ + "static/img/attestation3.f959c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/attestation3.png
// module id = aN0y
// module chunks = 2